import styled from "styled-components";

export const MenuDropdown = styled.div`
  position: absolute;
  right: 0;
  top: 43px;
  z-index: 2;
  width: 208px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  padding: 0;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07),
    0px 2px 6px 0px rgba(0, 0, 0, 0.1);
`;

export const MenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
`;

export const MenuItemStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;

  .clearFilters {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant} !important;
  }

  .textItem {
    flex: 1;
    min-width: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  &:active {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfacePressed}, ${theme.colors.surface.surface})`};
  }
`

export const MenuDivider = styled.div`
  position: relative;
  height: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 1px;
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
  }
`;
